// Categorize palettes based on type
// todo: mark palettes as colour-blind friendly? about 10% population are
export const PALETTE_CATEGORIES = {
    qualitative: [
        'Qualitive',
        'Category20',
        'iWantHue30',
        'SCHEDULE_DEFAULT_COLORS',
        'Prism',
        'Pastel',
        'Vivid',
        'Bold',
        'Retro Metro',
        'Dutch Field',
        'River Nights',
        'Spring Pastels',
        'Heated Metal',
        'Safe',
    ],
    sequential: [
        'Emerald',
        'Sunset',
        'To Red',
        'To Blue',
        'Blue to Yellow',
        'Grey to Red',
        'Black to Pink',
        'Blues',
    ],
    diverging: [
        'eS Default Thematic',
        'Temps',
        'Tropic',
        'Red to Blue',
        'Blue to Red',
        'Orange to Purple',
        'Pink Foam',
        'Salmon to Aqua',
    ]
};

const COLOR_PALETTES = {

    // https://spectrum.adobe.com/page/color-for-data-visualization/

    // https://support.heavy.ai/hc/en-us/articles/33519718087831-12-Data-Visualization-Color-Palettes-for-Telling-Better-Stories-with-Your-Data
    // ====== Categorical/Qualitive ======
    'Retro Metro': ["#ea5545", "#f46a9b", "#ef9b20", "#edbf33", "#ede15b", "#bdcf32", "#87bc45", "#27aeef", "#b33dc6"],
    'Dutch Field': ["#e60049", "#0bb4ff", "#50e991", "#e6d800", "#9b19f5", "#ffa300", "#dc0ab4", "#b3d4ff", "#00bfa0"],
    'River Nights': ["#b30000", "#7c1158", "#4421af", "#1a53ff", "#0d88e6", "#00b7c7", "#5ad45a", "#8be04e", "#ebdc78"],
    'Spring Pastels': ["#fd7f6f", "#7eb0d5", "#b2e061", "#bd7ebe", "#ffb55a", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7"],

    // "Qualitive" from http://colorbrewer2.org/#type=qualitative&scheme=Paired&n=12
    'Qualitive': ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#EBEB16", "#b15928"],

    // Qualitivecategory20
    // "category20" from https://vega.github.io/vega/docs/schemes/#category20
    'Category20': ["#1f77b4", "#aec7e8", "#ff7f0e", "#ffbb78", "#2ca02c", "#98df8a", "#d62728", "#ff9896", "#9467bd", "#c5b0d5", "#8c564b", "#c49c94", "#e377c2", "#f7b6d2", "#7f7f7f", "#c7c7c7", "#bcbd22", "#dbdb8d", "#17becf", "#9edae5"],

    // https://medialab.github.io/iwanthue/
    'iWantHue30': ["#d44975","#7dabd4","#5ad6d3","#d27d62","#b845d8","#d1862a","#d4442f","#61d754","#382239","#733124","#cb57ba","#aee043","#d8ca3c","#6145cb","#49287c","#936b6f","#334427","#c4de8c","#6bda9e","#cfb16b","#446c79","#559170","#a9cdc6","#d6a0cd","#5c5e95","#d0b8a3","#88376b","#7a6e32","#727fdc","#5e9239"],

    //DEFAULT_COLORS = ["#5D69B1","#085872","#DAA51B","#52BCA3", "#99C945","#CC61B0","#24796C"];
    // Shuffle colours around so that the inverse of the default point color (so from blue to orange), which is used to indicate selection,
    // is not similar to the default orange color in this range ("#E58606")
    'SCHEDULE_DEFAULT_COLORS': [
        "#085872","#52BCA3","#c3be16","#5D69B1",
        "#CC61B0","#24796C","#A5AA99"//,"#ED645A",
        //"#764E9F","#CC3A8E","#ece617","#E58606",
        //"#99C945"
    ],

    // https://carto.com/carto-colors/
    'Prism':  ["#5F4690","#1D6996","#38A6A5","#0F8554","#73AF48","#EDAD08","#E17C05","#CC503E","#94346E","#6F4070","#994E95","#666666"],
    'Pastel': ["#66C5CC","#F6CF71","#F89C74","#DCB0F2","#87C55F","#9EB9F3","#FE88B1","#C9DB74","#8BE0A4","#B497E7","#D3B484","#B3B3B3"],
    'Vivid':  ["#E58606","#5D69B1","#52BCA3","#99C945","#CC61B0","#24796C","#DAA51B","#2F8AC4","#764E9F","#ED645A","#CC3A8E","#A5AA99"],
    'Bold':   ["#7F3C8D","#11A579","#3969AC","#F2B701","#E73F74","#80BA5A","#E68310","#008695","#CF1C90","#f97b72","#4b4b8f","#A5AA99"],
    'Safe':   ["#88CCEE","#CC6677","#DDCC77","#117733","#332288","#AA4499","#44AA99","#999933","#882255","#661100","#6699CC","#888888"],

    // https://samples.azuremaps.com/heat-map-layer/heat-map-layer-options
    'Heated Metal': ["#000000", "#800080", "#FF0000", "#FFFF00", "#FFFFFF"],

    // ====== Sequential ======
    'Blue to Yellow': ["#115f9a", "#1984c5", "#22a7f0", "#48b5c4", "#76c68f", "#a6d75b", "#c9e52f", "#d0ee11", "#d0f400"],
    'Grey to Red': ["#d7e1ee", "#cbd6e4", "#bfcbdb", "#b3bfd1", "#a4a2a8", "#df8879", "#c86558", "#b04238", "#991f17"],
    'Black to Pink': ["#2e2b28", "#3b3734", "#474440", "#54504c", "#6b506b", "#ab3da9", "#de25da", "#eb44e8", "#ff80ff"],
    'Blues': ["#0000b3", "#0010d9", "#0020ff", "#0040ff", "#0060ff", "#0080ff", "#009fff", "#00bfff", "#00ffff"],
    'Emerald' : ["#d3f2a3", "#97e196", "#6cc08b", "#4c9b82", "#217a79", "#105965", "#074050"],
    'Sunset': ["#f3e79b", "#fac484", "#f8a07e", "#eb7f86", "#ce6693", "#a059a0", "#5c53a5"],
    'To Red': ['#fef0d9','#fdd49e','#fdbb84','#fc8d59','#ef6548','#d7301f','#990000'],
    'To Blue': ['#eff3ff','#c6dbef','#9ecae1','#6baed6','#4292c6','#2171b5','#084594'],

    // ====== Diverging ======
    'Blue to Red': ["#1984c5", "#22a7f0", "#63bff0", "#a7d5ed", "#e2e2e2", "#e1a692", "#de6e56", "#e14b31", "#c23728"],
    'Orange to Purple': ["#ffb400", "#d2980d", "#a57c1b", "#786028", "#363445", "#48446e", "#5e569b", "#776bcd", "#9080ff"],
    'Pink Foam': ["#54bebe", "#76c8c8", "#98d1d1", "#badbdb", "#dedad2", "#e4bcad", "#df979e", "#d7658b", "#c80064"],
    'Salmon to Aqua': ["#e27c7c", "#a86464", "#6d4b4b", "#503f3f", "#333333", "#3c4e4b", "#466964", "#599e94", "#6cd4c5"],
    'Tropic' : ["#009B9E", "#42B7B9", "#A7D3D4", "#F1F1F1", "#E4C1D9", "#D691C1", "#C75DAB"],
    'Temps' : ["#009392", "#39b185", "#9ccb86", "#e9e29c", "#eeb479", "#e88471", "#cf597e"],


    // https://colorbrewer2.org/
    'Red to Blue' : ['#b2182b','#ef8a62','#fddbc7','#f7f7f7','#d1e5f0','#67a9cf','#2166ac'],
    'Teal Rose': ["#009392", "#72aaa1", "#b1c7b3", "#f1eac8", "#e5b9ad", "#d98994", "#d0587e"],
    'eS Default Thematic': ['#d73027', '#fc8d59', '#fee08b',
        '#d9ef8b', '#91cf60', '#1a9850'],

};

export type ColorObject = {
    r: number,
    g: number,
    b: number
};

export default class ColorUtil {
    readonly palettes = COLOR_PALETTES;

    readonly BLACK = 4278190080;
    readonly BLACK_TRANSPARENT = 2130706432; // black with 50% transparency
    readonly WHITE = 4294967295;
    readonly OLD_LABEL_FILL_BLUE = 4278555852; // #0594CC
    readonly BLUE = 4278203391; // #0033ff
    readonly NEW_FONT_COLOR_NAVY = 4281220236; // #2E3C8C
    readonly HILITE_COLOR_TURQUOISE = 4278242559; // #00CCFF
    readonly RED = 4293263433; // #00CCFF

    private hexToRgbCache: Map<string, ColorObject>;
    
    constructor() {
        this.hexToRgbCache = new Map();
    }

    _printPalettes() {
        for (let k in this.palettes) {
            this._debug(this.palettes[k], k);
        }
    }

    /**
     * @function toCss Convert a server color to an rgbs css value e.g. 4294429900 -> "rgba(247,204,204,1)"
     *
     * @param (long) server color
     *
     * @return (String) rgba string
     */
    toCss(color: number): string {
        const a = (color >>> 24) / 0xFF; // CSS alpha needs to be a value between 0 and 1 : Not 0 - 255 as with rgb
        const r = (color & 0xFF0000) >> 16;
        const g = (color & 0xFF00) >> 8;
        const b = (color & 0xFF);

        const css = "rgba("+r+","+g+","+b+","+a+")";
        return css;
    }

    /**
     * 
     * @param color 
     * 
     * @returns 
     */
    serverColorToRGB(color: number): string {
        return this.toCss(color);
    }

    /**
     * 
     * @param serverColor 
     * 
     * @returns 
     */
    serverColorToRGB_arr(serverColor: number): number[] {
        const a = (serverColor >>> 24) / 0xFF; // CSS alpha needs to be a value between 0 and 1 : Not 0 - 255 as with rgb
        const r = (serverColor & 0xFF0000) >> 16;
        const g = (serverColor & 0xFF00) >> 8;
        const b = (serverColor & 0xFF);

        const rs = [r, g, b, a];
        return rs;
    }

    /**
     * 
     * @param dec 
     * 
     * @returns 
     */
    private IntToHex(dec: string): string {
        let result = (parseInt(dec).toString(16));
        if (result.length == 1)
            result = ("0" + result);
        return result.toUpperCase();
    }

    /**
     * 
     * @param r 
     * @param g 
     * @param b 
     * 
     * @returns 
     */
    private RgbToHex(r: string, g: string, b: string): string {
        return "" + this.IntToHex(r) + this.IntToHex(g) + this.IntToHex(b);
    }

    /**
     * @function RgbStringToHex Convert an rgb color value to a hexadecimal value
     *
     * @param (String) rgbString the rgb string to convert
     *
     * @return the hexadecimal representation of the rgb string
     */
    RgbStringToHex(rgbString: string): string {
        rgbString = rgbString.toString().toLowerCase();

        if (rgbString.indexOf("rgb(") == -1 || rgbString.indexOf(")") == -1) {
            if (rgbString.indexOf("#") == 0) {
                rgbString = rgbString.substring(1);
            }

            return rgbString;
        }

        rgbString = rgbString.substring(rgbString.indexOf("(") + 1, rgbString.indexOf(")"));
        const rgb = rgbString.split(',');
        const r = rgb[0];
        const g = rgb[1];

        let b: string;
        if (rgb.length == 3) {
            b = rgb[2];
        } else {
            b = "0";
        }

        return this.RgbToHex(r, g, b);
    }

    /**
     * Get hex color from a server color (e.g. 2160892262 => #CC9966)
     * 
     * @param color 
     * 
     * @returns 
     */
    getHex(color: number): string {
        let hexColor = (Number(color) & 0xFFFFFF).toString(16).toUpperCase();
        hexColor = hexColor.padStart(6, '0');
        return '#' + hexColor;
    }

    /**
     * 
     * @param color 
     * 
     * @returns 
     */
    serverToHex(color: number): string {
        return this.getHex(color);
    }

    /**
     * Get server color from a hex color (e.g. #CC9966 => 2160892262)
     */
    fromHex(color: string, alpha=1): number {
        const rgb = this.hexToRgb(color);
        return this.fromRGB(rgb, alpha);
    }

    /**
     * 
     * @param color 
     * @param alpha 
     * 
     * @returns 
     */
    serverFromHex(color: string, alpha=1): number {
        return this.fromHex(color, alpha);
    }

    /**
     * Get a hex color from a server color
     * TODO: this should return prefix #. every single time we use it we need to prepend the #
     * 
     * @param color
     * 
     * @returns
     */
    toHex(color: number|string): string {
        return Number(color).toString(16).toUpperCase().substring(2,8);
    }

    /**
     * 
     * @param color 
     * 
     * @returns 
     */
    hexFromServer(color: number|string): string {
        return this.toHex(color);
    }

    /**
     * Gets an rgb color object (object with r, g, and b properties) from a hex color
     */
    hexToRgb(hex: string): ColorObject | null | undefined {
        if (this.hexToRgbCache.has(hex)) {
            return this.hexToRgbCache.get(hex);
        }

        let cleanedHex = hex.charAt(0) === '#' ? hex.slice(1) : hex;

        if (cleanedHex.length === 3) {
            cleanedHex = cleanedHex[0] + cleanedHex[0]
                + cleanedHex[1] + cleanedHex[1]
                + cleanedHex[2] + cleanedHex[2];
        } else if (cleanedHex.length !== 6) {
            this.hexToRgbCache.set(hex, null);
            return null; // Invalid hex code
        }

        const r = parseInt(cleanedHex.slice(0, 2), 16);
        const g = parseInt(cleanedHex.slice(2, 4), 16);
        const b = parseInt(cleanedHex.slice(4, 6), 16);

        if (isNaN(r) || isNaN(g) || isNaN(b)) {
            this.hexToRgbCache.set(hex, null);
            return null; // Invalid hex code
        }

        const rgb = { r, g, b };
        this.hexToRgbCache.set(hex, rgb);
        return rgb;
    }

    /**
     * Get server color from a rgb color object (object with r, g and b properties)
     *
     * @param color color object
     * @param a alpha
     * 
     * @returns 
     */
    fromRGB(color: ColorObject, a: number): number {
        a = Math.round(a * 255) * 0x1000000;
        const r = (color.r << 16);
        const g = (color.g << 8);
        const b = (color.b);

        return a + r + g + b;
    }

    /**
     * Get transparency val (0-100) from server color (e.g. 2160892262 => 50)
     * 
     * @param color 
     * 
     * @returns 
     */
    getTransparency(color: number): number {
        return 100 - Math.round(this.getAlpha(color) / 255 * 100);
    }

    /**
     * Given a server color (e.g. 2160892262) and a transparency val (0-100), applies the new transparency to the colour and returns the new server color value
     * 
     * @param serverColor e.g. 2160892262
     * @param newTransparency (0-100)
     * 
     * @returns 
     */
    withTransparency(serverColor: number, newTransparency: number) {
        return this.withAlpha(serverColor, Math.round((100 - newTransparency) * 2.55));
    }

    /**
     * Get alpha val (0-255) from server color (e.g. 2160892262 => 128)
     * 
     * @param color 
     * 
     * @returns 
     */
    getAlpha(color: number | string): number {
        const hexColor = Number(color).toString(16).toUpperCase();
        let transparency = hexColor.substring(0,hexColor.length - 6);
        transparency = transparency ? transparency : '0';
        return parseInt("0x" + transparency);
    }

    /**
     * Given a server color (e.g. 2160892262) and a alpha val (0-255), applies the new alpha to the colour and returns the new server color value
     * 
     * @param color 
     * @param alpha 
     * 
     * @returns 
     */
    withAlpha(color: number, alpha: number): number {
        alpha =  Math.trunc(alpha);
        return (alpha * 0x1000000) + (color & 0xFFFFFF);
    }

    /**
     * 
     * @param color 
     * 
     * @returns 
     */
    invert(color: number): number {
        let rgb = color & 0xFFFFFF;
        const a = color - rgb; // preserve upper 8 bits
        rgb ^= 0xFFFFFF; // flip lower 24 bits
        const ret = a + rgb;
        return ret;
    }

    /**
     * 
     * @returns 
     */
    getRandomColor(): number {
        const letters = '0123456789ABCDEF';

        let color = '#';
        for (let i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * 16)];
        }

        return this.fromHex(color);
    }

    /**
     * get a color that's either brighter or darker than the given color.
     * @param source color
     * @param percent as a decimal between -1 and 1.
     * e.g. if es.util.color._debug(4280193279) is a light blue then es.util.color._debug(es.util.color.getShadeServerColor(4280193279, -0.25)) is a darker blue by 25%
     * see: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors/13542669
     */
    getShadeHexColor(color: string, percent: number): string {
        let f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
        return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
    }

    /**
     * 
     * @param color 
     * @param percent 
     * 
     * @returns 
     */
    getShadeServerColor(color: number, percent: number) {
        const hexColor = "#" + this.hexFromServer(color);
        return this.serverFromHex( this.getShadeHexColor(hexColor, percent) );
    }

    /**
     * Get the luminance of a color as a value between 0 (dark) to 1 (bright).
     * This can be useful to determine whether to use a brighter or darker colour for a border for example where the is no point in making a black geom have a darker border;
     * 
     * @param serverColor
     * 
     * @returns {number}
     */
    getLuminanceOfServerColor(serverColor: number): number {
        const rgba = this.serverColorToRGB_arr(serverColor);

        // Normalize RGB values to 0-1
        const r = rgba[0] / 255;
        const g = rgba[1] / 255;
        const b = rgba[2] / 255;

        // Calculate luminance
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }

    /**
     * 
     * @param colorHex 
     * 
     * @returns 
     */
    getLuminanceOfHexColor(colorHex: string): number {
        const serverColor = this.fromRGB( this.hexToRgb(colorHex), 1);
        return this.getLuminanceOfServerColor(serverColor);
    }

    // internal method. output server color to console as hex and sample colored block
    _debug(color: any, msg?: string) {

        if (Array.isArray(color)) {
            es.log.info("------[" + msg + "]------");
            color.forEach((col) => {
                this._debug(col);
            });
            es.log.info("------------------");
            return;
        }

        if (("" + color).startsWith("#")) { // accept both server and hex colors
            color = this.serverFromHex(color);
        }

        const hex = this.toHex(color);
        const rgba = this.toCss(color);
        es.log.info(
            (msg === undefined ? "" : msg + " :: ") +
            color +
            " == #" + hex +
            " == " + rgba +
            " transparency == " + this.getTransparency(color) +
            " alpha == " + this.getAlpha(color) + ")" +
            " == %c      ",
            "background: #" + hex
        );
    }

    /**
     *
     * @param color
     * 
     * @returns
     */
    private to9bits(color: string): string {
        const intColor = parseInt(color.slice(1), 16);
        const red = (intColor >> 16) & 0xFF;
        const green = (intColor >> 8) & 0xFF;
        const blue = intColor & 0xFF;

        const red9 = red >> 5;
        const green9 = green >> 5;
        const blue9 = blue >> 5;

        return '' + red9 + green9 + blue9;
    }

    /**
     * 
     * @param color9bits 
     * 
     * @returns 
     */
    private to24bits(color9bits: string): string {
        const red9 = parseInt(color9bits.charAt(0), 10);
        const green9 = parseInt(color9bits.charAt(1), 10);
        const blue9 = parseInt(color9bits.charAt(2), 10);

        const red = (red9 << 5) | (red9 << 2) | (red9 >> 1);
        const green = (green9 << 5) | (green9 << 2) | (green9 >> 1);
        const blue = (blue9 << 5) | (blue9 << 2) | (blue9 >> 1);

        const hex = '#' +
            red.toString(16).padStart(2, '0') +
            green.toString(16).padStart(2, '0') +
            blue.toString(16).padStart(2, '0');

        return hex.toUpperCase();
    }

    /**
     * Simplify the color to match a color on a 9bit palette (512 colors)
     * 
     * @param color hexColor starting with #
     * 
     * @returns serverColor
     * @deprecated
     */
    simplify(color:string): number {
        const bits = this.to9bits(color);
        return this.serverFromHex(this.to24bits(bits));
    }

    /**
     * Simplify the color to match a color on a 9bit palette (512 colors)
     *
     * @param color hexColor starting with #
     *
     * @returns color hexColor starting with #
     */
    simplifyHex(color: string): string {
        const bits = this.to9bits(color);
        return this.to24bits(bits);
    }

    /**
     * Simplify the color to match a color on a 9bit palette (512 colors)
     *
     * @param color server color
     *
     * @returns color server color
     */
    simplifyServer(color: number): number {
        const bits = this.to9bits(this.serverToHex(color));
        return this.serverFromHex(this.to24bits(bits));
    }
}
